// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3F4uo","box":"WorkspacesBox_box__8ePrN","node":"WorkspacesBox_node__3MBL5"};